export const fmtMoney = (n) =>
  "$" + Number(n || 0).toLocaleString("en-CA", { maximumFractionDigits: 0 });

export const fmtKm = (n) =>
  Number(n || 0).toLocaleString("en-CA") + " km";

export const telHref = (p) => `tel:${String(p || "").replace(/[^0-9+]/g, "")}`;

export const formatPhone = (p) => {
  const d = String(p || "").replace(/\D/g, "");
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  return p || "";
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};
